import apiService from "../apiService";

const apiPath = "/api/v1";

export const userService = {
  POST_LOGIN: (params) => {
    return apiService.post(`${apiPath}/login`, params);
  },
  POST_LINE_LOGIN: (params) => {
    return apiService.post(`${apiPath}/login/line`, params);
  },
  POST_CHECK_EMAIL: (params) => {
    return apiService.post(`${apiPath}/login/check-email`, params);
  },
  POST_LOGIN_GOOGLE: (params) => {
    return apiService.post(`${apiPath}/login/google`, params);
  },
  POST_FORGOT_PASSWORD: (params) => {
    return apiService.post(`${apiPath}/login/forgot-password`, params);
  },
  POST_SET_PASSWORD_REQUEST: (params) => {
    return apiService.post(`${apiPath}/login/set-password/request`, params);
  },
  POST_SET_PASSWORD: (params) => {
    return apiService.post(`${apiPath}/login/set-password`, params);
  },
  POST_CHECK_TOKEN: () => {
    return apiService.get(`${apiPath}/login/check_token`);
  },

  GET_MY_PROFILE: () => {
    return apiService.get(`${apiPath}/customer/me`);
  },
  GET_MY_WALLET: () => {
    return apiService.get(`${apiPath}/wallet/me`);
  },

  PUT_EMAIL_UPDATE_DETAIL: (params) => {
    return apiService.put(`${apiPath}/customer/me/email`, params);
  },
  PUT_MEMBER_TYPE_UPDATE_DETAIL: (params) => {
    return apiService.put(`${apiPath}/customer/me/member-type`, params);
  },
  POST_REGISTER_CUSTOMER: (params) => {
    return apiService.post(`${apiPath}/customer/register`, params);
  },

  GET_INSTRUMENT_DETAIL: (id) => {
    return apiService.get(`${apiPath}/instrument/${id}`);
  },
  POST_MY_INSTRUMENT: (params) => {
    return apiService.post(`${apiPath}/instrument/create`, params);
  },
  PUT_UPDATE_MY_INSTRUMENT: (id, params) => {
    return apiService.put(`${apiPath}/instrument/me/${id}`, params);
  },
  DELETE_MY_INSTRUMENT: (id) => {
    return apiService.delete(`${apiPath}/instrument/${id}`);
  },
  GET_MY_INSTRUMENT: (queryString) => {
    return apiService.get(
      `${apiPath}/instrument/me${queryString ? queryString : ""}`
    );
  },

  GET_MY_INSTRUMENT_DETAIL: (id, warentyType) => {
    return apiService.get(
      `${apiPath}/instrument-maintenance-history/me/product/${id}/${warentyType}`
    );
  },
  GET_MY_INSTRUMENT_APPOINTEMNT_LIST: () => {
    return apiService.get(
      `${apiPath}/instrument-maintenance-history/me/appointment`
    );
  },

  // ACTIVITY FORM
  GET_ACTIVITY_FORM_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/activity-form${queryString ? queryString : ""}`
    );
  },
  GET_ACTIVITY_FORM_DETAIL: (id) => {
    return apiService.get(`${apiPath}/activity-form/${id}`);
  },
  GET_ACTIVITY_FORM_PDPA_DETAIL: (id) => {
    return apiService.get(`${apiPath}/activity-form/${id}/pdpa`);
  },

  // ACTIVITY FORM HISTORY
  GET_MY_ACTIVITY_FORM_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/activity-form-history/me${queryString ? queryString : ""}`
    );
  },
  GET_MY_ACTIVITY_FORM_DETAIL: (id) => {
    return apiService.get(`${apiPath}/activity-form-history/${id}`);
  },
  GET_ACTIVITY_FORM_HISTORY_BY_ME_ACTIVITY: (id, memberType) => {
    return apiService.get(
      `${apiPath}/activity-form-history/me/activity/${id}?member_type=${memberType}`
    );
  },
  POST_ACTIVITY_FORM_HISTORY_REGISTER_PERSONAL_INFO: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/register/personal-info`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_REGISTER_PERSONAL_INFO_NO_MEMBER: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/register/personal-info-no-member`,
      params
    );
  },

  POST_ACTIVITY_FORM_HISTORY_SUBMIT_ANS: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/submit-answer`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_SUBMIT_ANS_NO_MEMBER: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/submit-answer-no-member`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_SENT_ANS: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/sent-answer`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_SENT_ANS_NO_MEMBER: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/sent-answer-no-member`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_REQUEST_EDIT: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/request-edit`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_REGISTER: (params) => {
    return apiService.post_formdata(
      `${apiPath}/activity-form-history/register`,
      params
    );
  },
  POST_ACTIVITY_FORM_HISTORY_CHECK_IN: (params) => {
    return apiService.post(
      `${apiPath}/activity-form-history/scan/admin`,
      params
    );
  },
  PUT_CUSTOMER_APPROVE_ADMIN_EDIT: (id) => {
    return apiService.put(
      `${apiPath}/activity-form-history/customer/me/approve/${id}`
    );
  },

  // ACTIVITY
  GET_ACTIVITY_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/activity${queryString ? queryString : ""}`
    );
  },
  GET_ACTIVITY_DETAIL: (id) => {
    return apiService.get(`${apiPath}/activity/${id}`);
  },

  // ACTIVITY HISTORY
  GET_MY_ACTIVITY: (queryString) => {
    return apiService.get(
      `${apiPath}/activity-history/me${queryString ? queryString : ""}`
    );
  },
  GET_ACTIVITY_HISTORY_BY_ME_ACTIVITY: (id, memberType) => {
    return apiService.get(
      `${apiPath}/activity-history/me/activity/${id}?member_type=${memberType}`
    );
  },
  // SEAT BOOKING (กิจกรรมจองที่นั่ง)
  GET_SEAT_BOOKING_INFO: (activityId) => {
    return apiService.get(`${apiPath}/seat-booking/activity/${activityId}/info`);
  },
  GET_SEAT_BOOKING_MAP: (activityId) => {
    return apiService.get(`${apiPath}/seat-booking/activity/${activityId}/map`);
  },
  GET_MY_SEAT_BOOKINGS: (activityId) => {
    return apiService.get(`${apiPath}/seat-booking/activity/${activityId}/bookings`);
  },
  GET_MY_SEAT_BOOKING_HISTORY: () => {
    return apiService.get(`${apiPath}/seat-booking/me/bookings`);
  },
  POST_SEAT_BOOKING_DRAFT: (activityId, params) => {
    return apiService.post(`${apiPath}/seat-booking/activity/${activityId}/draft`, params);
  },
  PUT_SEAT_BOOKING_DRAFT_SEATS: (bookingId, params) => {
    return apiService.put(`${apiPath}/seat-booking/draft/${bookingId}/seats`, params);
  },
  PUT_SEAT_BOOKING_DRAFT_DETAILS: (bookingId, params) => {
    return apiService.put(`${apiPath}/seat-booking/draft/${bookingId}/details`, params);
  },
  POST_SEAT_BOOKING_SLIP_CHECK: (bookingId, params) => {
    return apiService.post_formdata(`${apiPath}/seat-booking/draft/${bookingId}/slip`, params);
  },
  POST_SEAT_BOOKING_SUBMIT: (bookingId, params) => {
    return apiService.post_formdata(`${apiPath}/seat-booking/draft/${bookingId}/submit`, params);
  },
  POST_SEAT_BOOKING_ADMIN_SCAN: (params) => {
    return apiService.post(`${apiPath}/seat-booking/admin/scan`, params);
  },
  POST_ACTIVITY_HISTORY_REGISTER: (params) => {
    return apiService.post_formdata(
      `${apiPath}/activity-history/register`,
      params
    );
  },
  POST_ACTIVITY_HISTORY_LIMIT_REGISTER: (params) => {
    return apiService.post_formdata(
      `${apiPath}/activity-history/register-limit`,
      params
    );
  },
  POST_ACTIVITY_HISTORY_SCAN: (params) => {
    return apiService.post(`${apiPath}/activity-history/scan/customer`, params);
  },
  GET_ONLINE_FORM_CERTIFICATE_INFO: (id, member_type) => {
    return apiService.get(
      `${apiPath}/activity-form-history/certificate/info/${id}?member_type=${member_type}`
    );
  },
  POST_ONLINE_FORM_CERTIFICATE: (params) => {
    return apiService.post(`${apiPath}/activity-form-history/certificate`, params);
  },
  POST_ACTIVITY_HISTORY_CERTIFICATE: (params) => {
    return apiService.post(`${apiPath}/activity-history/certificate`, params);
  },
  POST_ACTIVITY_QUESTION_EDIT: (params) => {
    return apiService.post_formdata(
      `${apiPath}/activity-history/me/question`,
      params
    );
  },

  // CERTIFICATE
  GET_CERTIFICATE_LANDING_DETAIL: (id) => {
    return apiService.get(`${apiPath}/certificate/landing/${id}`);
  },

  // FRONTEND SETTING
  GET_BANNER_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/banner/landing${queryString ? queryString : ""}`
    );
  },

  // REWARD
  GET_REWARD_LIST: (queryString) => {
    return apiService.get(`${apiPath}/reward${queryString ? queryString : ""}`);
  },
  GET_REWARD_DETAIL: (id) => {
    return apiService.get(`${apiPath}/reward/${id}`);
  },

  // REWARD HISTORY
  GET_MY_REWARD: () => {
    return apiService.get(`${apiPath}/reward-history/me`);
  },
  GET_REWARD_HISTORY_DETAIL: (id) => {
    return apiService.get(`${apiPath}/reward-history/${id}`);
  },
  POST_REWARD_REDEEM: (params) => {
    return apiService.post(`${apiPath}/reward-history/redeem`, params);
  },
  POST_SHIPPING: (params) => {
    return apiService.post(`${apiPath}/reward-history/shipping`, params);
  },
  PUT_USE_E_COUPON: (id) => {
    return apiService.put(`${apiPath}/reward-history/e-conpon/active/${id}`);
  },

  // REWARD E VOUCHER
  GET_MY_REWARD_E_VOUCHER_LIST: () => {
    return apiService.get(`${apiPath}/reward-e-voucher/me`);
  },
  GET_MY_REWARD_E_VOUCHER_DETAIL: (id) => {
    return apiService.get(`${apiPath}/reward-e-voucher/me/${id}`);
  },
  GET_REWARD_E_VOUCHER_DETAIL: (id) => {
    return apiService.get(`${apiPath}/reward-e-voucher/${id}`);
  },
  POST_REWARD_E_VOUCHER_SCAN: (params) => {
    return apiService.post(`${apiPath}/reward-e-voucher/scan`, params);
  },

  // NEW
  GET_NEW_LIST: (queryString) => {
    return apiService.get(`${apiPath}/new${queryString ? queryString : ""}`);
  },
  GET_NEW_DETAIL: (id) => {
    return apiService.get(`${apiPath}/new/${id}`);
  },

  // PRODUCT_WARRANTEE
  GET_MY_PRODUCT_WARRANTEE: (queryString) => {
    return apiService.get(
      `${apiPath}/product-warrantee/me${queryString ? queryString : ""}`
    );
  },
  GET_MY_PRODUCT_WARRANTEE_DETAIL: (id) => {
    return apiService.get(`${apiPath}/product-warrantee/${id}`);
  },
  GET_PRODUCT_WARRANTEE_ACTIVE_BY_SN: (id) => {
    return apiService.get(`${apiPath}/product-warrantee/serial-no/${id}`);
  },
  POST_PRODUCT_WARRANTEE_REGISTER: (params) => {
    return apiService.post(`${apiPath}/product-warrantee/register`, params);
  },
  POST_PRODUCT_WARRANTEE_MEMBER_REGISTER: (params) => {
    return apiService.post(
      `${apiPath}/product-warrantee/register-member`,
      params
    );
  },
  POST_UPLOAD_SLIP: (params) => {
    return apiService.post(
      `${apiPath}/product-warrantee/upload/member`,
      params
    );
  },
  POST_NO_MEMBER_UPLOAD_SLIP: (params) => {
    return apiService.post_formdata(
      `${apiPath}/product-warrantee/upload`,
      params
    );
  },
  POST_UPLOAD_COPERATE_REGIS: (params) => {
    return apiService.post(
      `${apiPath}/product-warrantee/upload/coperate`,
      params
    );
  },

  // QUESTION
  GET_QUESTION_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/question${queryString ? queryString : ""}`
    );
  },
  GET_QUESTION_DETAIL: (id) => {
    return apiService.get(`${apiPath}/question/${id}`);
  },

  // ASSESSMENT
  GET_ASSESSMENT_BY_ME_QUESTION: (id, memberType) => {
    return apiService.get(
      `${apiPath}/assessment/me/question/${id}?member_type=${memberType}`
    );
  },
  POST_ASSESSMENT_DETAIL: (params) => {
    return apiService.post(`${apiPath}/assessment/question`, params);
  },

  // ADMIN
  POST_ADMIN_LOGIN: (params) => {
    return apiService.post(`${apiPath}/admin-login`, params);
  },
  POST_ADMIN_ACTIVITY_SCAN: (params) => {
    return apiService.post(`${apiPath}/activity-history/scan/admin`, params);
  },

  // BRANCH
  GET_BRANCH_LIST: (queryString) => {
    return apiService.get(`${apiPath}/branch${queryString ? queryString : ""}`);
  },

  // LUCKY DRAW
  GET_LUCKY_DRAW_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/luckydraw-reward${queryString ? queryString : ""}`
    );
  },
  POST_PLAY_LUCKY_DRAW: (params) => {
    return apiService.post(`${apiPath}/luckydraw-reward/playgame`, params);
  },

  // PDPA
  GET_PDPA_LATEST: () => {
    return apiService.get(`${apiPath}/pdpa/latest`);
  },
  GET_PDPA_ACCEPTED_HISTORY: (id) => {
    return apiService.get(`${apiPath}/pdpa-history/me/pdpa/${id}`);
  },

  POST_PDPA_ACCEPTED_HISTORY: (params) => {
    return apiService.post(`${apiPath}/pdpa-history/accept`, params);
  },
  POST_PDPA_ACCEPTED_NOT_LOGIN_HISTORY: (params) => {
    return apiService.post(`${apiPath}/pdpa-history/accept-not-login`, params);
  },

  // NOTIFICATION
  GET_NOTIFICATION_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/notification-history/me/${queryString ? queryString : ""}`
    );
  },
  GET_POPUP_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/popup-history/me/${queryString ? queryString : ""}`
    );
  },
  POST_NOTIFICATION_READ_ALL: () => {
    return apiService.post(`${apiPath}/notification-history/read-all`);
  },
  PUT_POPUP_READ_DETAIL: (id) => {
    return apiService.put(`${apiPath}/popup-history/read/${id}`);
  },

  // ORGANIZATION
  PUT_MY_ORGANIZE_UPDATE_DETAIL: (params) => {
    return apiService.put(`${apiPath}/organization/me/update`, params);
  },
  POST_ORGANIZATION_CREATE: (params) => {
    return apiService.post(`${apiPath}/organization/register`, params);
  },
  POST_ORGANIZATION_ONLY_CREATE: (params) => {
    return apiService.post(`${apiPath}/organization/register/member`, params);
  },

  POST_CUSTOMER_CHECK_PHONE_NUMBER: (params) => {
    return apiService.post(`${apiPath}/customer/check-phone-number`, params);
  },
  // otpToken = verify_token ที่ได้จาก POST_OTP_VERIFY
  GET_CUSTOMER_ACCOUNT_BY_PROFILE: (id, otpToken) => {
    return apiService.get(`${apiPath}/customer/phone-number/${id}`, {
      otp_token: otpToken,
    });
  },

  // params ต้องมี otp_token (verify_token ที่ได้จาก POST_OTP_VERIFY)
  POST_CUSTOMER_SYNC_LINE: (params) => {
    return apiService.post(`${apiPath}/customer/sync/line`, params);
  },

  // OTP
  POST_OTP_REQUEST: (params) => {
    return apiService.post(`${apiPath}/sms/request-otp`, params);
  },
  POST_OTP_VERIFY: (params) => {
    return apiService.post(`${apiPath}/sms/verify-otp`, params);
  },

  // BOOKING
  GET_MY_BOOKING_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/booking/customer/me/latest${queryString ? queryString : ""}`
    );
  },
  POST_BOOKING_CREATE: (params) => {
    return apiService.post(`${apiPath}/booking/create`, params);
  },
  POST_BOOKING_CANCEL: (params) => {
    return apiService.post(`${apiPath}/booking/cancel`, params);
  },

  // CALENDAR
  GET_HOLIDATE_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/holiday${queryString ? queryString : ""}`
    );
  },
  GET_TIME_SLOT_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/time-slot${queryString ? queryString : ""}`
    );
  },

  // SHOW ROOM
  GET_SHOWROOM_BOOKING_BY_CUS_BOOKING_ID: (cusID, bookingID) => {
    return apiService.get(
      `${apiPath}/showroom-visit/customer/${cusID}/booking/${bookingID}`
    );
  },
  POST_SHOWROOM_SCAN_QR_BY_ADMIN: (params) => {
    return apiService.post(`${apiPath}/showroom-visit/scan-qr/admin`, params);
  },
  POST_SHOWROOM_SCAN_QR_BY_CUSTOMER: (params) => {
    return apiService.post(
      `${apiPath}/showroom-visit/scan-qr/customer`,
      params
    );
  },

  GET_SHORTCUT_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/shortcut/landing${queryString ? queryString : ""}`
    );
  },

  // MEDIA
  POST_ONLINE_FORM_UPLOAD: (params) => {
    return apiService.post_formdata(
      `${apiPath}/media/upload/activity-form-history`,
      params
    );
  },
  POST_PRODUCT_WARRANRY_UPLOAD: (params, callback) => {
    return apiService.post_formdata(
      `${apiPath}/media/upload/product-warranty`,
      params,
      callback
    );
  },
  POST_MEDIA_DELETE: (params) => {
    return apiService.post(`${apiPath}/media/delete`, params);
  },

  // ROOM RESERVATION
  GET_ROOM_LIST: (queryString) => {
    return apiService.get(`${apiPath}/room${queryString ? queryString : ""}`);
  },
  GET_ROOM_DETAIL: (id) => {
    return apiService.get(`${apiPath}/room/${id}`);
  },
  GET_ROOM_BOOKING_MY_UPCOMING_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/room-booking/upcoming${queryString ? queryString : ""}`
    );
  },
  GET_ROOM_REC_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/room/recommended${queryString ? queryString : ""}`
    );
  },
  GET_ROOM_BOOKING_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/room-booking${queryString ? queryString : ""}`
    );
  },
  GET_ROOM_BOOKING_DETAIL: (id) => {
    return apiService.get(`${apiPath}/room-booking/${id}`);
  },
  GET_ROOM_AVAILABILITY_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/room-availability${queryString ? queryString : ""}`
    );
  },

  POST_ROOM_UPLOAD: (params, callback) => {
    return apiService.post_formdata(
      `${apiPath}/media/upload/room`,
      params,
      callback
    );
  },

  POST_ROOM_BOOKING_DRAFT: (params) => {
    return apiService.post(`${apiPath}/room-booking/draft`, params);
  },
  POST_ROOM_BOOKING_SENT: (params) => {
    return apiService.post(`${apiPath}/room-booking/sent`, params);
  },
  PATCH_ROOM_BOOKING_CANCEL: (id, params) => {
    return apiService.patch(
      `${apiPath}/room-booking/${id}/customer/cancel`,
      params
    );
  },
  PATCH_ROOM_BOOKING_SLIP_UPDATE: (id, params) => {
    return apiService.patch(
      `${apiPath}/room-booking/${id}/customer/receipt`,
      params
    );
  },

  POST_UPLOAD_MUSIC_HALL_SLIP: (params) => {
    return apiService.post_formdata(`${apiPath}/media/upload/slip`, params);
  },

  GET_EQUIPMENT_LIST: (queryString) => {
    return apiService.get(
      `${apiPath}/equipment${queryString ? queryString : ""}`
    );
  },
};
